import React, { useEffect, useState, useRef } from "react";
import { withNamespaces } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Button,
  Spinner,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import { formatUnitsForReport } from "../../../../helpers/units";
import { useLocation } from "react-router-dom";
import { getDateRangeFromMonth } from "../../../../helpers/commonFunctions";

const ItemClosedOrders = (props) => {
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [page, setPage] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [sizePerPage] = useState(30);

  const location = useLocation();

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const monthYear = params.get("month");
    const orderId = params.get("order_id");

    if (monthYear) {
      const dateRange = getDateRangeFromMonth(monthYear);
      if (dateRange) {
        setDateFrom(dateRange.startDate);
        setDateTo(dateRange.endDate);
        if (orderId) {
          setSearchQueryOrderID(orderId);
        }
      }
    } else {
      const currentDay = new Date();
      setDateFrom(formatDate(currentDay));
      setDateTo(formatDate(currentDay));
    }
  }, []);

  const [searchQueryBranch, setSearchQueryBranch] = useState("");
  const [searchQueryOrderID, setSearchQueryOrderID] = useState("");
  const [localFilteredOrders, setLocalFilteredOrders] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [shouldLoadData, setShouldLoadData] = useState(false);

  const performLocalSearch = async (query1, query2) => {
    if (isSearching) return;

    if (
      (!query1 || query1.trim() === "") &&
      (!query2 || query2.trim() === "")
    ) {
      setSearchQueryBranch("");
      setSearchQueryOrderID("");
      setAllOrders([]);
      setLocalFilteredOrders([]);
      setPage(1);
      setShouldLoadData(true);
      return;
    }

    if (query1 && query1.length < 3 && query2 && query2.length < 3) return;

    setIsSearching(true);
    setAllOrders([]);
    setLocalFilteredOrders([]);
    setPage(1);
    try {
      await loadAllOrders(query1, query2);
    } catch (error) {
      console.error("API search failed:", error);
      setAllOrders([]);
      setLocalFilteredOrders([]);
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      performLocalSearch(searchQueryOrderID, searchQueryBranch);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQueryBranch, searchQueryOrderID]);

  useEffect(() => {
    if (!searchQueryBranch && !searchQueryOrderID && shouldLoadData) {
      loadAllOrders();
      setShouldLoadData(false);
    }
  }, [page, shouldLoadData]);

  const [allOrders, setAllOrders] = useState([]);
  const isInitialRender = useRef(true);
  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    setAllOrders([]);
    setLocalFilteredOrders([]);
    loadAllOrders(searchQueryOrderID, searchQueryBranch);
  }, [page]);

  const loadAllOrders = async (orderIdQuery, branchQuery) => {
    try {
      setIsSearching(true);
      const days_diff = moment(dateTo).diff(dateFrom, "days");
      if (days_diff > 31) {
        setAllOrders([]);
        setLocalFilteredOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (days_diff < 0) {
        setAllOrders([]);
        setLocalFilteredOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }
      setAllOrders([]);
      setLocalFilteredOrders([]);
      const url = process.env.REACT_APP_BASEURL + "itemorders/getall_closed";
      const response = await postSubmitForm(url, {
        date_from: dateFrom,
        date_to: dateTo,
        page: page,
        limit: sizePerPage,
        order_query: orderIdQuery || "",
        branch_query: branchQuery || "",
      });

      if (response?.status === 1) {
        setAllOrders(response.data);
        setTotalSize(response.totalPages);
        setLocalFilteredOrders(response.data);
      }
    } catch (error) {
      showNotification("Error searching orders", "Error");
    } finally {
      setIsSearching(false);
    }
  };

  const [POItems, setPOItems] = useState([]);
  const loadSuupliers = async (e) => {
    let url = process.env.REACT_APP_BASEURL + "suppliers/get_by_categories";
    let response = await postSubmitForm(url, { categories: [e.category] });
    if (response.status === 1) {
      const supplier = response.data.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      const updatedSuppliers = supplier.map((s) => ({
        value: s.value || s.name,
        name: s.name,
      }));
      setPOItems((prev) =>
        prev.map((itm) =>
          itm.category === e.category
            ? {
                ...itm,
                suppliers: updatedSuppliers,
                selSupp: itm.selSupp || e.selSupp,
              }
            : itm,
        ),
      );
    } else {
      showNotification(response.message, "Error");
    }
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Sub-Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Available"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];
  const [orderDetailsModal, setOrderDetailsModal] = useState();
  const [selectedOrder, setSelectedOrder] = useState();
  const populateCartFromDraft = async (po_bucket) => {
    const newCartCategorizesItems = po_bucket.map((category) => ({
      category: category.category,
      selSupp: category.supplier,
      items: category.items.map((item) => ({
        ...item,
        quantity: item.po_quantity,
        category: category.category,
      })),
      suppliers: [],
    }));
    // console.log(newCartCategorizesItems,"NEw");
    setPOItems(newCartCategorizesItems);

    for (const category of newCartCategorizesItems) {
      await loadSuupliers(category);
    }
  };

  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        const rowNumber = (+page - 1) * +sizePerPage + (+rowIndex + 1);
        return rowNumber;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),
      headerFormatter: (column) => (
        <div>
          {column.text}
          <div className="mt-1">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search Order ID..."
              value={searchQueryOrderID}
              onChange={(e) => setSearchQueryOrderID(e.target.value)}
            />
          </div>
        </div>
      ),
      headerStyle: (colum, colIndex) => ({
        width: "20%",
        verticalAlign: "top",
      }),
      style: { cursor: "pointer" },
    },
    {
      dataField: "branch_details.name",
      text: props.t("Branch Name"),
      headerFormatter: (column) => (
        <div>
          {column.text}
          <div className="mt-1">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search Branch..."
              value={searchQueryBranch}
              onChange={(e) => setSearchQueryBranch(e.target.value)}
            />
          </div>
        </div>
      ),
      headerStyle: (colum, colIndex) => ({
        width: "12%",
        verticalAlign: "top",
      }),
      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Branch Remarks"),
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      dataField: "createdAt",
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Is Urgent?"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row) => {
        if (row.is_urgent) {
          return props.t("Yes");
        } else {
          return props.t("No");
        }
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "admin_remarks",
      text: props.t("Centre Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            <button
              class="btn btn-secondary btn-sm mr-2"
              onClick={() => {
                setSelectedOrder(row);
                setOrderDetailsModal(!orderDetailsModal);
                if (row.po_bucket_status === "PO Generated") {
                  populateCartFromDraft(row.po_bucket);
                }
              }}
            >
              {props.t("Details")}
            </button>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.item_details}
          columns={columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
  };

  const columns_delivered_items = [
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   text: props.t("Sub-Category"),
    //   dataField: "sub_category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Delivered From"),
      dataField: "delivered_from",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Delivered Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(
          row.delivered_quantity && row.delivered_quantity,
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(
          row.received_quantity && row.received_quantity,
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Remarks"),
      dataField: "remarks",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    return style;
  };

  const PO_Columns = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      footer: false,
    },
    {
      text: props.t("Sub Category"),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      footer: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      footer: false,
    },
    {
      text: props.t("Order Qty."),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Price"),
      dataField: "po_price",
      formatter: (cell, row) => {
        return (row.po_price || 0) + " / " + row.unit_for_po;
        // return 0
      },
      sort: false,
      editable: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      footer: false,
    },
    {
      text: props.t("Total"),
      dataField: "total_price",
      sort: false,
      formatter: (cell, row) => {
        return row.total_price.toFixed(2) || 0;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
      footer: (columnData) => {
        const total = columnData.reduce((acc, item) => acc + item, 0);
        return total.toFixed(2);
      },
    },
  ];

  function getData() {
    let centre_dispatched = [];
    let centralStore = localStorage.getItem("store_name");
    let delivery_details = selectedOrder?.delivery_details || [];
    // delivery_details.map((item) => {
    //   if (item.delivered_from === centralStore) {
    //     centre_dispatched.push(item);
    //   } })
    return delivery_details;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Central Store")}
            breadcrumbItem1={props.t("Item Order")}
            breadcrumbItem2={props.t("Closed Orders")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllOrders(
                                searchQueryOrderID,
                                searchQueryBranch,
                              );
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Closed Orders")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all closed orders here")}
                  </CardSubtitle>
                  {/* <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row> */}
                  <ToolkitProvider
                    keyField="_id"
                    key={`${allOrders + page + localFilteredOrders}`}
                    data={localFilteredOrders}
                    columns={columns_external}
                    noDataIndication={props.t("No data to display.")}
                    bootstrap4
                    search
                  >
                    {(props_table) => (
                      <div>
                        <BootstrapTable
                          striped
                          hover
                          condensed
                          expandRow={expandRow}
                          rowStyle={rowStyle}
                          {...props_table.baseProps}
                          onTableChange={(type, { page }) => {
                            if (type === "pagination") {
                              setPage(page);
                            }
                          }}
                          noDataIndication={() => (
                            <div className="text-center p-3">
                              {isSearching ? (
                                <div>
                                  <Spinner
                                    color="primary"
                                    size="sm"
                                    className="mr-2"
                                  />
                                  {props.t("Loading...")}
                                </div>
                              ) : searchQueryBranch ||
                                (searchQueryOrderID &&
                                  allOrders.length <= 0) ? (
                                props.t("No matching results found")
                              ) : (
                                props.t("No data to display.")
                              )}
                            </div>
                          )}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                  <div>
                    <br />

                    {[...Array(totalSize)].map((x, i) => (
                      <button
                        key={i}
                        onClick={() => {
                          setPage(i + 1);
                        }}
                        className={page === i + 1 ? "btn btn-primary" : "btn"}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                  <Modal
                    size="lg"
                    isOpen={orderDetailsModal}
                    toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                  >
                    <ModalHeader
                      toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                    >
                      {props.t("Delivery Details")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12} md={12}>
                                    <Label>Ordered Items</Label>
                                  </Col>

                                  <Col lg={12}>
                                    <BootstrapTable
                                      bootstrap4
                                      keyField="name"
                                      data={
                                        selectedOrder &&
                                        selectedOrder.item_details
                                      }
                                      columns={columns}
                                      noDataIndication="No data to display."
                                      striped
                                      hover
                                      condensed
                                    />
                                    <hr />
                                  </Col>

                                  {selectedOrder &&
                                  selectedOrder.delivery_details &&
                                  selectedOrder.delivery_details.length > 0 ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>{props.t("Delivered Items")} </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12} className="mb-4">
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={getData()}
                                          columns={columns_delivered_items}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                        <hr />
                                      </Col>
                                    </>
                                  ) : null}

                                  {selectedOrder &&
                                    selectedOrder.po_bucket_status ===
                                      "PO Generated" &&
                                    selectedOrder.po_bucket?.length > 0 && (
                                      <Col lg={12}>
                                        <Col xl={12} lg={12} md={12}>
                                          <Label
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                            }}
                                          >
                                            {/* Generated PO   */}
                                            {props.t(
                                              "Purchase Order generated successfully for below items",
                                            )}
                                          </Label>
                                        </Col>
                                        <Col lg={12} xl={12}>
                                          {POItems.map((item, ind) => {
                                            if (item.items.length > 0) {
                                              return (
                                                <>
                                                  <Row key={item.item_id}>
                                                    <Col lg={8}>
                                                      <Label>
                                                        {props.t("Category")}:{" "}
                                                        {item.category}
                                                      </Label>
                                                    </Col>
                                                    <Col lg={4}>
                                                      <AvForm>
                                                        <AvField
                                                          name="supplier"
                                                          type="select"
                                                          disabled={true}
                                                          value={
                                                            item.selSupp
                                                              ? typeof item.selSupp ===
                                                                "object"
                                                                ? item.selSupp
                                                                    .id ||
                                                                  item.selSupp
                                                                    .name
                                                                : item.selSupp
                                                              : ""
                                                          }
                                                        >
                                                          <option value="">
                                                            {props.t(
                                                              "--Select Supplier--",
                                                            )}
                                                          </option>
                                                          {item.suppliers &&
                                                            item.suppliers.map(
                                                              (e) => (
                                                                <option
                                                                  key={e.value}
                                                                  value={
                                                                    e.value
                                                                  }
                                                                  name={e.value}
                                                                >
                                                                  {e.name}
                                                                </option>
                                                              ),
                                                            )}
                                                        </AvField>
                                                      </AvForm>
                                                    </Col>
                                                  </Row>
                                                  <ToolkitProvider
                                                    bootstrap4
                                                    keyField="item_id"
                                                    data={item.items}
                                                    columns={PO_Columns}
                                                    noDataIndication={props.t(
                                                      "No data to display.",
                                                    )}
                                                    search
                                                  >
                                                    {(props) => (
                                                      <div>
                                                        <BootstrapTable
                                                          bootstrap4
                                                          striped
                                                          hover
                                                          condensed
                                                          {...props.baseProps}
                                                        />
                                                      </div>
                                                    )}
                                                  </ToolkitProvider>
                                                </>
                                              );
                                            }
                                          })}
                                        </Col>
                                      </Col>
                                    )}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(ItemClosedOrders)),
);
